import { service } from '../../../../helpers/http'

export const ActionGetScheduleActivities = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceScheduleActivity',
        action: 'getScheduleActivities',
        payload: payload
    })
}

export const ActionPostScheduleActivities = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceScheduleActivity',
        action: 'postScheduleActivities',
        payload: payload
    })
}

export const ActionPutScheduleActivities = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceScheduleActivity',
        action: 'putScheduleActivities',
        payload: payload
    })
}

export const ActionDeleteScheduleActivities = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceScheduleActivity',
        action: 'deleteScheduleActivities',
        payload: payload
    })
}
